module.exports = __webpack_public_path__ + "7263faa2783bca16fe70bb6fef5d6a46.svg";